import React from 'react';
import {
  MdOutlineHome,
  MdSearch,
  MdHomeWork,
  MdOutlineReceiptLong,
  MdVerified,
  MdAccountCircle
} from 'react-icons/md';
import './MobileBottomNav.css';

const MobileBottomNav = ({ activeSection, onNavClick }) => {
  const navItems = [
    { key: 'home', label: 'Home', icon: MdOutlineHome },
    { key: 'listings', label: 'Browse', icon: MdSearch },
    { key: 'your-home', label: 'Your Home', icon: MdHomeWork },
    { key: 'my-bills', label: 'Bills', icon: MdOutlineReceiptLong },
    { key: 'score', label: 'Score', icon: MdVerified },
    { key: 'account', label: 'Account', icon: MdAccountCircle },
  ];

  return (
    <nav className="mobile-bottom-nav" aria-label="Mobile Navigation">
      {navItems.map((item) => {
        const IconComponent = item.icon;
        const isActive =
          activeSection === item.key ||
          (item.key === 'score' && activeSection === 'score-details');

        return (
          <button
            key={item.key}
            type="button"
            className={`mobile-bottom-nav-item ${isActive ? 'active' : ''}`}
            onClick={() => onNavClick(item.key)}
            aria-current={isActive ? 'page' : undefined}
          >
            <IconComponent className="mobile-bottom-nav-icon" />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
